import { render, staticRenderFns } from "./BaseIconRoundButtonAdd.vue?vue&type=template&id=4d2eb499&scoped=true&"
import script from "./BaseIconRoundButtonAdd.vue?vue&type=script&lang=js&"
export * from "./BaseIconRoundButtonAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2eb499",
  null
  
)

export default component.exports